/* RP i18n + měna: překlady a měna z layoutu (window.RP_I18N / RP_MONEY) */
window.rpT=function(k,f){return (window.RP_I18N&&window.RP_I18N[k])||f;};
window.rpRate=function(){var r=parseFloat(window.Shopify&&Shopify.currency&&Shopify.currency.rate);return r>0?r:1;};
window.rpMoney=function(c){try{var m=window.RP_MONEY||{};return new Intl.NumberFormat(String(m.locale||document.documentElement.lang||'de').replace('_','-'),{style:'currency',currency:m.currency||(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(c/100);}catch(e){return (c/100).toFixed(2)+' €';}};
/* ───────────────────────────────────────────────
   RubberPaint Theme — Tectonic Gallery
   Light interactivity layer (no framework).
   ─────────────────────────────────────────────── */

(() => {
  'use strict';

  /* ───── Utility ───── */
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const $ = (sel, root = document) => root.querySelector(sel);

  /* ═══════════════════════════════════════════════
     1) Mobile menu toggle
     ═══════════════════════════════════════════════ */
  function initMobileMenu() {
    const trigger = $('[data-mobile-menu-toggle]');
    const menu = $('[data-mobile-menu]');
    if (!trigger || !menu) return;

    trigger.addEventListener('click', () => {
      const isHidden = menu.classList.toggle('hidden');
      trigger.setAttribute('aria-expanded', String(!isHidden));
    });
  }

  /* ═══════════════════════════════════════════════
     2) Product tabs
     ═══════════════════════════════════════════════ */
  function initProductTabs() {
    const root = $('[data-product-tabs]');
    if (!root) return;

    const tabs = $$('[data-tab]', root);
    const panels = $$('[data-tab-panel]', root);

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
        panels.forEach((p) => p.classList.toggle('hidden', p.dataset.tabPanel !== target));
      });
    });
  }

  /* ═══════════════════════════════════════════════
     3) Product gallery — thumbnail → main image
     ═══════════════════════════════════════════════ */
  function initProductGallery() {
    const mainImg = $('#GalleryMainImg');
    const mainVideo = $('#GalleryMainVideo');
    if (!mainImg) return;

    function showImage(src, srcset) {
      if (src) mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      mainImg.classList.remove('hidden');
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.classList.add('hidden');
        mainVideo.innerHTML = '';
        mainVideo.removeAttribute('src');
      }
    }

    function showVideo(sourcesJson, poster) {
      if (!mainVideo) return;
      let sources = [];
      try { sources = JSON.parse('[' + sourcesJson + ']'); } catch (e) {}
      mainVideo.innerHTML = sources
        .map((s) => `<source src="${s.url}" type="${s.mime}">`)
        .join('');
      if (poster) mainVideo.poster = poster;
      mainImg.classList.add('hidden');
      mainVideo.classList.remove('hidden');
      mainVideo.load();
      mainVideo.play().catch(() => {});
    }

    $$('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (thumb.dataset.mediaType === 'video') {
          showVideo(thumb.dataset.videoSources, thumb.dataset.poster);
        } else {
          showImage(thumb.dataset.src, thumb.dataset.srcset);
        }

        $$('[data-gallery-thumb]').forEach((t) => {
          const active = t === thumb;
          t.classList.toggle('ring-2', active);
          t.classList.toggle('ring-primary', active);
          t.classList.toggle('ring-offset-2', active);
          t.classList.toggle('ring-offset-surface', active);
          t.setAttribute('aria-selected', String(active));
        });
      });
    });
  }

  /* ═══════════════════════════════════════════════
     4) Quantity stepper
     ═══════════════════════════════════════════════ */
  function initQuantity() {
    $$('[data-qty-wrapper]').forEach((wrap) => {
      const input = $('[data-qty-input]', wrap);
      const dec = $('[data-qty-decrement]', wrap);
      const inc = $('[data-qty-increment]', wrap);
      if (!input) return;
      dec?.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      inc?.addEventListener('click', () => {
        const v = Math.max(1, parseInt(input.value || '1', 10) + 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ═══════════════════════════════════════════════
     5) Size pill → variant switcher
        Updates hidden id input + price label + URL ?variant=
     ═══════════════════════════════════════════════ */
  function initVariantSelector() {
    const form = $('[data-product-form]');
    if (!form) return;

    const idInput = $('[data-variant-id-input]', form);
    const priceEl = $('[data-price]');
    const unitPriceEl = $('[data-unit-price]');
    const ctaText = $('[data-add-to-cart-text]');
    const ctaBtn = $('[data-add-to-cart]');
    const pills = $$('[data-size-pill]', form);

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        if (pill.hasAttribute('disabled')) return;
        const vid = pill.dataset.variantId;
        const price = pill.dataset.variantPrice;
        const unitPrice = pill.dataset.variantUnitPrice;
        const available = pill.dataset.variantAvailable === 'true';

        pills.forEach((p) => p.setAttribute('aria-checked', String(p === pill)));

        if (idInput) idInput.value = vid;
        if (priceEl && price) priceEl.textContent = price;
        if (unitPriceEl && unitPrice) unitPriceEl.textContent = unitPrice;
        document.dispatchEvent(new CustomEvent('rp:variant-changed', { detail: { variantId: vid, price, unitPrice } }));

        if (ctaBtn) {
          ctaBtn.disabled = !available;
          ctaBtn.setAttribute('aria-disabled', String(!available));
        }
        if (ctaText) {
          ctaText.textContent = available
            ? document.documentElement.dataset.localeAddToCart || rpT('addToCart','In den Warenkorb')
            : rpT('soldOut','Ausverkauft');
        }

        // Update URL ?variant=… for shareability
        const url = new URL(window.location);
        url.searchParams.set('variant', vid);
        history.replaceState({}, '', url);
      });
    });
  }

  /* ═══════════════════════════════════════════════
     6) Add to cart — AJAX + cart count update
     ═══════════════════════════════════════════════ */
  async function initAddToCart() {
    const form = $('[data-product-form] form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = e.submitter || $('[data-add-to-cart]', form);
      const originalText = submitBtn?.querySelector('[data-add-to-cart-text]')?.textContent;
      if (submitBtn) submitBtn.disabled = true;

      try {
        const formData = new FormData(form);
        const res = await fetch(`${window.Shopify.routes.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        // Refresh cart count
        const cartRes = await fetch(`${window.Shopify.routes.root || '/'}cart.js`);
        const cart = await cartRes.json();
        $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));

        // Brief success state
        if (submitBtn?.querySelector('[data-add-to-cart-text]')) {
          submitBtn.querySelector('[data-add-to-cart-text]').textContent = '✓ ' + rpT('added','Hinzugefügt');
          setTimeout(() => {
            submitBtn.querySelector('[data-add-to-cart-text]').textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        }

        // Notify cart drawer to open
        document.dispatchEvent(new CustomEvent('rp:cart-added', { detail: cart }));
      } catch (err) {
        console.error('Cart add failed', err);
        if (submitBtn) submitBtn.disabled = false;
        alert(rpT('addError','Fehler beim Hinzufügen zum Warenkorb. Bitte erneut versuchen.'));
      }
    });
  }

  /* ═══════════════════════════════════════════════
     7) Home — Applications tabs
     ═══════════════════════════════════════════════ */
  function initApplicationsTabs() {
    const root = $('[data-applications-tabs]');
    if (!root) return;

    const tabs = $$('[data-app-tab]', root);
    const panels = $$('[data-app-panel]', root);
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.appTab;
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.classList.toggle('bg-primary', active);
          t.classList.toggle('text-on-primary', active);
          t.classList.toggle('bg-surface', !active);
          t.classList.toggle('text-secondary', !active);
        });
        panels.forEach((p) => p.classList.toggle('hidden', p.dataset.appPanel !== id));
      });
    });
  }

  /* ═══════════════════════════════════════════════
     8) FAQ — search + sidebar active state
     ═══════════════════════════════════════════════ */
  function initFAQ() {
    const root = $('[data-faq-root]');
    if (!root) return;

    /* Search filter — hides <details> whose visible text doesn't match query */
    const search = $('[data-faq-search]');
    if (search) {
      search.addEventListener('input', (e) => {
        const q = e.target.value.trim().toLowerCase();
        $$('details', root).forEach((d) => {
          const text = d.textContent.toLowerCase();
          d.style.display = !q || text.includes(q) ? '' : 'none';
        });
      });
    }

    /* Sidebar — highlight active category on scroll */
    const links = $$('.faq-cat-link', root);
    const sections = links
      .map((link) => $('#' + link.dataset.catId, root))
      .filter(Boolean);

    if (sections.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const id = entry.target.id;
            links.forEach((l) => {
              const active = ('cat-' + l.dataset.catId) === id;
              l.classList.toggle('bg-surface-container-low', active);
              l.classList.toggle('text-primary', active);
              l.classList.toggle('text-secondary', !active);
            });
          });
        },
        { rootMargin: '-30% 0px -60% 0px', threshold: 0 }
      );
      sections.forEach((s) => io.observe(s));
    }
  }

  /* ═══════════════════════════════════════════════
     9) PDP info sections — sticky sidebar nav active state
     ═══════════════════════════════════════════════ */
  function initProductInfoNav() {
    const root = $('[data-product-info]');
    if (!root) return;
    const links = $$('.info-link', root);
    // Look up by ID globally so sections OUTSIDE the info-sections root (e.g. product-colors) can also be tracked
    const articles = links.map(l => document.getElementById('info-' + l.dataset.infoLink)).filter(Boolean);
    if (!articles.length) return;

    const setActive = (id) => {
      links.forEach(l => {
        const active = l.dataset.infoLink === id;
        l.classList.toggle('active', active);
        l.classList.toggle('bg-surface-container-low', active);
        l.classList.toggle('text-on-surface', active);
        l.classList.toggle('text-secondary', !active);
      });
    };

    // Pick the topmost article whose top edge has crossed the trigger line (~25% from viewport top).
    // We sort by CURRENT bounding-rect top each time so it works regardless of DOM order
    // (calculator + colors sections may sit outside product-info-sections).
    const triggerOffset = () => window.innerHeight * 0.25;

    const update = () => {
      const line = triggerOffset();
      const positions = articles.map(a => ({ id: a.id, top: a.getBoundingClientRect().top }));
      positions.sort((a, b) => a.top - b.top);
      let activeId = positions[0].id;
      for (const p of positions) {
        if (p.top <= line) {
          activeId = p.id;
        } else {
          break;
        }
      }
      setActive(activeId.replace('info-', ''));
    };

    let raf = null;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; update(); });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ═══════════════════════════════════════════════
     10) Article TOC — auto-generate from H2 in body
     ═══════════════════════════════════════════════ */
  function initArticleTOC() {
    const tocEl = $('#ArticleTOC');
    const body = $('#ArticleBody');
    if (!tocEl || !body) return;

    const h2s = $$('h2', body);
    if (!h2s.length) {
      tocEl.parentElement.style.display = 'none';
      return;
    }

    // Inject anchor IDs into each H2 (slugify)
    const slugify = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

    const links = [];
    h2s.forEach((h, i) => {
      if (!h.id) h.id = 'sec-' + (slugify(h.textContent) || i);
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.className = 'block px-3 py-2 rounded-lg text-on-surface-variant hover:bg-surface-container-low hover:text-on-surface transition-colors';
      a.dataset.tocTarget = h.id;
      tocEl.appendChild(a);
      links.push(a);
    });

    // Active state on scroll
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            links.forEach(l => {
              const active = l.dataset.tocTarget === e.target.id;
              l.classList.toggle('bg-surface-container-low', active);
              l.classList.toggle('text-primary', active);
              l.classList.toggle('font-bold', active);
            });
          }
        });
      }, { rootMargin: '-15% 0px -75% 0px' });
      h2s.forEach(h => io.observe(h));
    }

    // Remove "Wird beim Laden generiert" placeholder
    const placeholder = tocEl.querySelector('em');
    if (placeholder) placeholder.remove();
  }

  /* ═══════════════════════════════════════════════
     11) Search overlay (predictive via /search/suggest.json)
     ═══════════════════════════════════════════════ */
  function initSearchOverlay() {
    const overlay = $('[data-search-overlay]');
    if (!overlay) return;

    const input = $('[data-search-input]', overlay);
    const results = $('[data-search-results]', overlay);
    const empty = $('[data-search-empty]', overlay);

    let debounceTimer;
    let lastQuery = '';

    const open = () => {
      overlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input?.focus(), 50);
    };
    const close = () => {
      overlay.classList.add('hidden');
      document.body.style.overflow = '';
    };

    $$('[data-search-toggle]').forEach(t => t.addEventListener('click', open));
    overlay.querySelectorAll('[data-search-close]').forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.classList.contains('hidden')) close();
    });

    async function search(q) {
      try {
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Suggest failed');
        const data = await res.json();
        renderResults(data.resources?.results || {}, q);
      } catch (err) {
        results.innerHTML = '<p class="text-error py-4">Suche fehlgeschlagen.</p>';
      }
    }

    function renderResults(r, q) {
      empty.style.display = 'none';
      const products = r.products || [];
      const collections = r.collections || [];
      const articles = r.articles || [];

      if (!products.length && !collections.length && !articles.length) {
        results.innerHTML = `<p class="text-secondary py-8 text-center">Keine Ergebnisse für „${q}".</p>`;
        return;
      }

      let html = '';
      if (products.length) {
        html += '<div class="mb-8"><p class="label text-primary mb-4">Produkte</p><div class="grid grid-cols-2 md:grid-cols-4 gap-4">';
        products.forEach((p) => {
          html += `<a href="${p.url}" class="group">
            <div class="aspect-square bg-surface-container-low rounded-lg overflow-hidden mb-2">
              ${p.image ? `<img src="${p.image}" alt="" class="w-full h-full object-cover">` : ''}
            </div>
            <p class="font-headline font-bold text-title-sm text-on-surface group-hover:text-primary line-clamp-2">${p.title}</p>
            <p class="text-label-md text-primary mt-1">${p.price || ''}</p>
          </a>`;
        });
        html += '</div></div>';
      }
      if (collections.length) {
        html += '<div class="mb-6"><p class="label text-primary mb-3">Kategorien</p><div class="flex flex-wrap gap-2">';
        collections.forEach((c) => {
          html += `<a href="${c.url}" class="px-4 py-2 rounded-full bg-surface-container-low hover:bg-surface-container text-body-md text-on-surface">${c.title}</a>`;
        });
        html += '</div></div>';
      }
      if (articles.length) {
        html += '<div><p class="label text-primary mb-3">Ratgeber</p><ul class="space-y-2">';
        articles.forEach((a) => {
          html += `<li><a href="${a.url}" class="block py-2 text-body-md text-on-surface hover:text-primary">${a.title}</a></li>`;
        });
        html += '</ul></div>';
      }
      results.innerHTML = html;
    }

    input?.addEventListener('input', (e) => {
      const q = e.target.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) {
        empty.style.display = '';
        results.querySelectorAll(':scope > *:not([data-search-empty])').forEach(el => el.remove());
        return;
      }
      if (q === lastQuery) return;
      lastQuery = q;
      debounceTimer = setTimeout(() => search(q), 200);
    });
  }

  /* ═══════════════════════════════════════════════
     12) Cart drawer (off-canvas + AJAX cart)
     ═══════════════════════════════════════════════ */
  function initCartDrawer() {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;

    const open = () => {
      drawer.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      refresh();
    };
    const close = () => {
      drawer.classList.add('hidden');
      document.body.style.overflow = '';
    };

    // Intercept cart icon clicks
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-cart-open]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }
      const closeBtn = e.target.closest('[data-cart-close], [data-cart-backdrop]');
      if (closeBtn && drawer.contains(closeBtn)) {
        close();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.classList.contains('hidden')) close();
    });

    // Refresh drawer content via /cart.js
    async function refresh() {
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await res.json();
        updateDrawer(cart);
        $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      } catch (err) {
        console.error('Cart refresh failed', err);
      }
    }

    function money(cents) {
      return window.rpMoney(cents);
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    function renderCartItems(cart) {
      const itemsContainer = $('[data-cart-items]', drawer);
      if (!itemsContainer) return;
      if (!cart.items || cart.items.length === 0) {
        itemsContainer.innerHTML = `
          <div class="p-10 text-center" data-cart-empty>
            <span class="material-symbols-outlined text-secondary" style="font-size: 3rem;">shopping_cart</span>
            <p class="mt-4 text-body-md text-on-surface-variant">${(rpT('cartEmpty','Dein Warenkorb ist leer.'))}</p>
            <button type="button" class="btn-primary mt-6" data-cart-close>${(rpT('continueShopping','Weiter einkaufen'))}</button>
          </div>`;
        return;
      }
      const lis = cart.items.map(line => {
        const title = escapeHtml(String(line.product_title || line.title || '').split('–')[0].trim());
        const variantTitle = line.variant_title && line.variant_title !== 'Default Title'
          ? `<p class="text-label-sm text-secondary mt-0.5">${escapeHtml(line.variant_title)}</p>` : '';
        let imgSrc = line.image || (line.featured_image && line.featured_image.url) || '';
        if (imgSrc && !imgSrc.includes('width=')) {
          imgSrc = imgSrc + (imgSrc.includes('?') ? '&' : '?') + 'width=200';
        }
        const img = imgSrc ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(title)}" class="w-full h-full object-cover" loading="lazy" width="200" height="200">` : '';
        return `
          <li class="p-6 flex gap-4" data-cart-item data-line-key="${escapeHtml(line.key)}">
            <a href="${escapeHtml(line.url)}" class="shrink-0 w-20 h-20 bg-surface-container-low rounded-lg overflow-hidden">${img}</a>
            <div class="flex-1 min-w-0">
              <a href="${escapeHtml(line.url)}" class="font-headline font-bold text-title-sm text-on-surface hover:text-primary line-clamp-2">${title}</a>
              ${variantTitle}
              <p class="font-headline font-bold text-title-sm text-primary mt-2">${money(line.final_line_price)}</p>
              <div class="mt-3 flex items-center gap-3">
                <div class="flex items-center bg-surface-container-low rounded-lg">
                  <button type="button" class="px-3 py-1 text-secondary hover:text-primary" data-qty-decrease aria-label="−">−</button>
                  <span class="px-2 text-body-sm font-bold" data-qty-display>${line.quantity}</span>
                  <button type="button" class="px-3 py-1 text-secondary hover:text-primary" data-qty-increase aria-label="+">+</button>
                </div>
                <button type="button" class="text-label-sm text-secondary hover:text-error transition-colors" data-cart-remove>${(rpT('remove','Entfernen'))}</button>
              </div>
            </div>
          </li>`;
      }).join('');
      itemsContainer.innerHTML = `<ul class="divide-y divide-outline-variant/15">${lis}</ul>`;
    }

    function renderCartFooter(cart) {
      let footer = $('[data-cart-footer]', drawer);
      if (!cart.items || cart.items.length === 0) {
        if (footer) footer.hidden = true;
        return;
      }
      if (footer) { footer.hidden = false; return; }
      if (!footer) {
        const aside = drawer.querySelector('aside') || drawer.firstElementChild;
        if (!aside) return;
        const cartUrl = (window.Shopify?.routes?.root || '/') + 'cart';
        footer = document.createElement('footer');
        footer.className = 'p-6 bg-surface-container-lowest space-y-3';
        footer.setAttribute('data-cart-footer','');
        footer.innerHTML = `
          <div class="flex items-baseline justify-between">
            <span class="label text-secondary">${(rpT('subtotal','Zwischensumme'))}</span>
            <span class="font-headline font-black text-headline-sm text-on-surface" data-cart-subtotal>${money(cart.total_price)}</span>
          </div>
          <p class="text-label-sm text-secondary">${(rpT('taxNote','inkl. MwSt., zzgl. Versand'))}</p>
          <a href="${escapeHtml(cartUrl)}" class="btn-secondary w-full">${(rpT('cartTitle','Warenkorb'))}</a>
          <a href="${escapeHtml(cartUrl)}/checkout" class="btn-primary w-full">${(rpT('checkout','Zur Kasse'))}</a>`;
        aside.appendChild(footer);
      }
    }

    function updateDrawer(cart) {
      $$('[data-cart-count-text]', drawer).forEach(el => el.textContent = `(${cart.item_count})`);
      renderCartItems(cart);
      renderCartFooter(cart);
      $$('[data-cart-subtotal]', drawer).forEach(el => el.textContent = money(cart.total_price));

      // Broadcast cart state so other UI (announcement bar, sticky chips) can update
      document.dispatchEvent(new CustomEvent('rp:cart-updated', { detail: cart }));

      // Free shipping bar
      const threshold = parseFloat(document.documentElement.dataset.freeShipThreshold || '199') * rpRate();
      const total = cart.total_price / 100;
      const shipBar = $('[data-cart-shipping]', drawer);
      if (shipBar) {
        if (total >= threshold) {
          shipBar.innerHTML = `<p class="text-body-sm text-primary font-headline font-bold flex items-center gap-2"><span class="material-symbols-outlined icon-sm" style="font-variation-settings: 'FILL' 1;">check_circle</span>${rpT('freeUnlocked','Versand ist kostenlos!')}</p>`;
        } else {
          const remaining = rpMoney(Math.round((threshold - total) * 100));
          const progress = Math.min((total / threshold) * 100, 100);
          shipBar.innerHTML = `
            <p class="text-body-sm text-on-surface-variant mb-2">${rpT('freeRemaining','Noch <strong>__AMT__</strong> bis kostenlosem Versand').replace('__AMT__', remaining)}</p>
            <div class="h-2 bg-surface-container rounded-full overflow-hidden"><div class="h-full bg-primary transition-all duration-500" style="width: ${progress}%"></div></div>`;
        }
      }
    }

    // Discount code in cart (drawer + cart page) — Cart API first, /discount/<code> URL as fallback
    async function applyDiscountCodes(codes, box) {
      const root = window.Shopify?.routes?.root || '/';
      const status = box.querySelector('[data-discount-status]');
      const say = (msg, ok) => { if (!status) return; status.textContent = msg; status.classList.remove('hidden'); status.classList.toggle('text-primary', !!ok); status.classList.toggle('text-error', !ok); };
      const res = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
      const cart = await res.json();
      if (!cart || !Array.isArray(cart.discount_codes)) {
        // Older Cart API: let Shopify apply the code on the way to the cart page
        const last = codes[codes.length - 1];
        if (last) location.href = root + 'discount/' + encodeURIComponent(last) + '?redirect=' + encodeURIComponent(root + 'cart');
        return null;
      }
      return cart;
    }
    function renderDiscounts(cart) {
      $$('[data-discount-box]').forEach(box => {
        const list = box.querySelector('[data-discount-applied]');
        if (!list) return;
        const ok = (cart.discount_codes || []).filter(d => d.applicable);
        list.innerHTML = ok.map(d => `<li class="flex items-center justify-between text-body-sm" data-discount-code="${escapeHtml(d.code)}">
          <span class="inline-flex items-center gap-1 text-primary font-bold"><span class="material-symbols-outlined icon-sm">sell</span>${escapeHtml(d.code)}</span>
          <button type="button" class="text-secondary underline" data-discount-remove="${escapeHtml(d.code)}">${escapeHtml(rpT('discountRemove','Entfernen'))}</button></li>`).join('');
      });
      $$('[data-cart-subtotal]').forEach(el => el.textContent = money(cart.total_price));
      if (drawer.contains(document.activeElement) || !drawer.classList.contains('hidden')) updateDrawer(cart);
    }
    async function onDiscountApply(box) {
      const input = box.querySelector('[data-discount-input]');
      const btn = box.querySelector('[data-discount-apply]');
      const status = box.querySelector('[data-discount-status]');
      const code = (input?.value || '').trim().toUpperCase();
      if (!code) return;
      if (btn) btn.disabled = true;
      try {
        const cartNow = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
        const keep = (cartNow.discount_codes || []).filter(d => d.applicable && d.code.toUpperCase() !== code).map(d => d.code);
        const cart = await applyDiscountCodes(keep.concat(code), box);
        if (!cart) return;
        const hit = (cart.discount_codes || []).find(d => d.code.toUpperCase() === code);
        if (hit && hit.applicable) {
          if (status) { status.textContent = rpT('discountApplied','Code eingelöst'); status.classList.remove('hidden','text-error'); status.classList.add('text-primary'); }
          if (input) input.value = '';
          renderDiscounts(cart);
        } else {
          // Shopify keeps a non-applicable code on the cart; drop it again so it doesn't haunt the checkout
          const cleaned = keep.length ? await applyDiscountCodes(keep, box) : await applyDiscountCodes([''], box);
          if (status) { status.textContent = rpT('discountInvalid','Dieser Code ist ungültig oder nicht anwendbar.'); status.classList.remove('hidden','text-primary'); status.classList.add('text-error'); }
          if (cleaned) renderDiscounts(cleaned);
        }
      } catch (err) {
        console.error('Discount apply failed', err);
      } finally {
        if (btn) btn.disabled = false;
      }
    }
    document.addEventListener('click', async (e) => {
      const apply = e.target.closest('[data-discount-apply]');
      if (apply) { e.preventDefault(); const box = apply.closest('[data-discount-box]'); if (box) onDiscountApply(box); return; }
      const rm = e.target.closest('[data-discount-remove]');
      if (rm) {
        e.preventDefault();
        const box = rm.closest('[data-discount-box]'); if (!box) return;
        try {
          const cartNow = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
          const keep = (cartNow.discount_codes || []).filter(d => d.applicable && d.code !== rm.dataset.discountRemove).map(d => d.code);
          const cart = await applyDiscountCodes(keep.length ? keep : [''], box);
          if (cart) { const s = box.querySelector('[data-discount-status]'); if (s) s.classList.add('hidden'); renderDiscounts(cart); }
        } catch (err) { console.error('Discount remove failed', err); }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      const input = e.target.closest('[data-discount-input]');
      if (!input) return;
      e.preventDefault();
      const box = input.closest('[data-discount-box]'); if (box) onDiscountApply(box);
    });

    // Quantity update + remove (event delegation)
    drawer.addEventListener('click', async (e) => {
      const incBtn = e.target.closest('[data-qty-increase]');
      const decBtn = e.target.closest('[data-qty-decrease]');
      const remBtn = e.target.closest('[data-cart-remove]');
      if (!incBtn && !decBtn && !remBtn) return;

      // Prevent any default form submit / link follow that could trigger reload
      e.preventDefault();
      e.stopPropagation();

      const item = e.target.closest('[data-cart-item]');
      if (!item) return;
      const key = item.dataset.lineKey;
      let qty = parseInt(item.querySelector('[data-qty-display]')?.textContent || '1', 10);

      if (incBtn) qty++;
      else if (decBtn) qty = Math.max(0, qty - 1);
      else if (remBtn) qty = 0;

      // Disable buttons during AJAX to prevent double-clicks
      [incBtn, decBtn, remBtn].forEach(b => { if (b) b.disabled = true; });
      item.style.opacity = '0.5';

      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();
        // Re-render drawer items + footer + count badge without reloading page
        updateDrawer(cart);
        $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      } catch (err) {
        console.error('Cart update failed', err);
        item.style.opacity = '1';
        [incBtn, decBtn, remBtn].forEach(b => { if (b) b.disabled = false; });
      }
    });

    // Open drawer after successful AJAX add-to-cart
    document.addEventListener('rp:cart-added', () => open());

    // ─── Quick-add popover (product cards in showcase) ───
    // Toggle variant picker on click; close on outside click; add via AJAX
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-quickadd-toggle]');
      if (toggle) {
        e.preventDefault();
        const wrap = toggle.closest('[data-quickadd]');
        const panel = wrap?.querySelector('[data-quickadd-panel]');
        if (!panel) return;
        // Close other open panels
        document.querySelectorAll('[data-quickadd-panel]').forEach((p) => {
          if (p !== panel) p.classList.add('hidden');
        });
        document.querySelectorAll('[data-quickadd-toggle][aria-expanded="true"]').forEach((b) => {
          if (b !== toggle) b.setAttribute('aria-expanded', 'false');
        });
        const willOpen = panel.classList.contains('hidden');
        panel.classList.toggle('hidden');
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      // Close popovers when clicking outside
      if (!e.target.closest('[data-quickadd]')) {
        document.querySelectorAll('[data-quickadd-panel]').forEach((p) => p.classList.add('hidden'));
        document.querySelectorAll('[data-quickadd-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }
    });

    // Variant button → AJAX add to cart → open drawer
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quickadd-variant]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.style.opacity = '0.5';
      const label = btn.querySelector('span:first-child');
      const originalLabel = label?.textContent;
      if (label) label.textContent = '...';
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('add failed');
        // Close panel
        btn.closest('[data-quickadd-panel]')?.classList.add('hidden');
        btn.closest('[data-quickadd]')?.querySelector('[data-quickadd-toggle]')?.setAttribute('aria-expanded', 'false');
        // Open cart drawer
        document.dispatchEvent(new CustomEvent('rp:cart-added'));
      } catch (err) {
        console.error('Quick-add failed', err);
        if (label && originalLabel) label.textContent = originalLabel;
      } finally {
        btn.disabled = false;
        btn.style.opacity = '1';
        if (label && originalLabel) label.textContent = originalLabel;
      }
    });

    // Upsell button: add recommended product to cart without navigating
    drawer.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-add-upsell]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.style.opacity = '0.5';
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        location.reload();
      } catch (err) {
        console.error('Cart upsell add failed', err);
        btn.disabled = false;
        btn.style.opacity = '1';
      }
    });

    // PDP upsell forms: intercept submit → AJAX add → open drawer
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form');
      if (!form) return;
      const btn = form.querySelector('[data-pdp-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      const fd = new FormData(form);
      btn.disabled = true;
      btn.style.opacity = '0.6';
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          body: fd
        });
        document.dispatchEvent(new CustomEvent('rp:cart-added'));
        // small delay so drawer opens with fresh content
        setTimeout(() => { refresh(); }, 100);
      } catch (err) {
        console.error('PDP upsell add failed', err);
      } finally {
        btn.disabled = false;
        btn.style.opacity = '1';
      }
    });
  }

  /* ═══════════════════════════════════════════════
     13) Sticky mobile ATC (shows when main ATC scrolled off)
     ═══════════════════════════════════════════════ */
  function initStickyMobileATC() {
    const bar = $('[data-sticky-atc]');
    if (!bar) return;
    const mainATC = $('[data-add-to-cart]');
    if (!mainATC) return;

    if (!('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          bar.classList.add('translate-y-full');
        } else {
          bar.classList.remove('translate-y-full');
        }
      });
    }, { rootMargin: '0px 0px -80px 0px' });

    io.observe(mainATC);

    // When sticky button clicked → submit main form
    $('[data-sticky-atc-btn]', bar)?.addEventListener('click', () => {
      const mainForm = $('[data-product-form] form');
      if (mainForm) mainForm.requestSubmit();
    });

    // Mirror variant price changes
    document.addEventListener('rp:variant-changed', (e) => {
      const stickyPrice = $('[data-sticky-price]');
      if (stickyPrice && e.detail?.price) stickyPrice.textContent = e.detail.price;
    });
  }

  /* ═══════════════════════════════════════════════
     Boot
     ═══════════════════════════════════════════════ */
  function init() {
    initMobileMenu();
    initProductTabs();
    initProductGallery();
    initQuantity();
    initVariantSelector();
    initAddToCart();
    initApplicationsTabs();
    initFAQ();
    initProductInfoNav();
    initArticleTOC();
    initSearchOverlay();
    initCartDrawer();
    initStickyMobileATC();
    initAnnouncementBar();
    initCalculator();
    initPdpCalculator();
  }

  /* ═══════════════════════════════════════════════
     14b) Product page mini calculator — m² + coats → cheapest bucket combo
        of THIS product's sizes; adds the whole combo to the cart.
     ═══════════════════════════════════════════════ */
  function initPdpCalculator() {
    const root = document.querySelector('[data-pdp-calc]');
    const cfgEl = document.querySelector('[data-pdp-calc-config]');
    if (!root || !cfgEl) return;
    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { console.error('PDP calculator config invalid', err); return; }

    const areaInput = root.querySelector('[data-pdp-area]');
    const coatBtns = Array.from(root.querySelectorAll('[data-pdp-coats]'));
    const resultEl = root.querySelector('[data-pdp-result]');
    const addBtn = root.querySelector('[data-pdp-add]');
    const addText = root.querySelector('[data-pdp-add-text]');
    const i18n = cfg.i18n || {};
    const locale = (cfg.locale || document.documentElement.lang || 'de').toLowerCase();
    const decSep = locale.startsWith('en') ? '.' : ',';
    const fmtKg = (kg) => (Math.round(kg * 10) / 10).toFixed(1).replace(/\.0$/, '').replace('.', decSep);
    const variants = (cfg.variants || []).filter((v) => v.available && v.size_kg > 0 && v.id).sort((a, b) => b.size_kg - a.size_kg);
    let coats = 2;

    // Cheapest combination of available sizes that covers `need` kg; ties →
    // fewer buckets, then less leftover. Three sizes, so brute force is fine.
    function cheapest(need) {
      let best = null;
      const walk = (i, counts, kg, cents) => {
        if (i === variants.length) {
          if (kg + 1e-9 < need) return;
          const packs = counts.reduce((a, b) => a + b, 0);
          if (!best || cents < best.cents || (cents === best.cents && (packs < best.packs || (packs === best.packs && kg < best.kg)))) best = { counts: counts.slice(), kg, cents, packs };
          return;
        }
        const v = variants[i];
        const max = Math.ceil(Math.max(need - kg, 0) / v.size_kg);
        for (let c = 0; c <= max; c++) { counts[i] = c; walk(i + 1, counts, kg + c * v.size_kg, cents + c * v.price_cents); }
        counts[i] = 0;
      };
      walk(0, new Array(variants.length).fill(0), 0, 0);
      return best;
    }

    function update() {
      const area = Math.max(0, parseFloat(String(areaInput.value).replace(',', '.')) || 0);
      if (!area || !variants.length) { resultEl.hidden = true; addBtn.hidden = true; delete addBtn.dataset.cartItems; return; }
      const need = area * coats * (cfg.coverage || 0.2) * 1.10;   // +10 % reserve, same as the big calculator
      const best = cheapest(need);
      const areaStr = String(area).replace('.', decSep);
      const head = (i18n.result || 'Für {{ area }} m² und {{ coats }} Schichten brauchen Sie ca. {{ kg }} kg')
        .replace('__AREA__', areaStr).replace('__COATS__', String(coats)).replace('__KG__', fmtKg(need));
      if (!best) { resultEl.innerHTML = esc(head) + ' — ' + esc(i18n.no_combo || ''); resultEl.hidden = false; addBtn.hidden = true; return; }
      const parts = [];
      best.counts.forEach((c, i) => { if (c) parts.push(c + '× ' + variants[i].title); });
      const single = best.packs === 1;
      const line = single
        ? (i18n.enough || '{{ pack }} reicht.').replace('__PACK__', parts[0].replace(/^1× /, ''))
        : (i18n.combo || 'Empfehlung:') + ' ' + parts.join(' + ');
      resultEl.innerHTML = esc(head) + '<br><b>' + esc(line) + '</b>';
      resultEl.hidden = false;
      // Single bucket: just select that size so the normal "In den Warenkorb" works too.
      if (single) {
        const idx = best.counts.findIndex((c) => c === 1);
        const pill = document.querySelector('[data-size-pill][data-variant-id="' + variants[idx].id + '"]');
        if (pill && pill.getAttribute('aria-checked') !== 'true') pill.click();
      }
      addText.textContent = (i18n.add || 'Alles in den Warenkorb · {{ price }}').replace('__PRICE__', rpMoney(best.cents));
      addBtn.dataset.cartItems = JSON.stringify(best.counts.map((c, i) => ({ id: variants[i].id, quantity: c })).filter((x) => x.quantity > 0));
      addBtn.hidden = false;
      addBtn.disabled = false;
    }
    function esc(t) { return String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch])); }

    areaInput.addEventListener('input', update);
    // Enter in the m² field must not submit the product form.
    areaInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); update(); } });
    coatBtns.forEach((btn) => btn.addEventListener('click', () => {
      coats = parseInt(btn.dataset.pdpCoats, 10) || 2;
      coatBtns.forEach((b) => b.setAttribute('aria-checked', String(b === btn)));
      update();
    }));
    addBtn.addEventListener('click', async () => {
      const items = JSON.parse(addBtn.dataset.cartItems || '[]');
      if (!items.length) return;
      const prev = addText.textContent;
      addBtn.disabled = true; addText.textContent = i18n.adding || 'Wird hinzugefügt…';
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await cartRes.json();
        $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
        addText.textContent = '✓ ' + (i18n.added || 'Im Warenkorb');
        document.dispatchEvent(new CustomEvent('rp:cart-added', { detail: cart }));
        setTimeout(() => { addText.textContent = prev; addBtn.disabled = false; }, 1800);
      } catch (err) {
        console.error('PDP calculator ATC failed', err);
        addText.textContent = prev; addBtn.disabled = false;
        alert(rpT('addError', 'Fehler beim Hinzufügen zum Warenkorb. Bitte erneut versuchen.'));
      }
    });
  }

  /* ═══════════════════════════════════════════════
     15) Material calculator — m² + coats → optimal bucket combo
     ═══════════════════════════════════════════════ */
  function initCalculator() {
    const root = document.querySelector('[data-calculator]');
    if (!root) return;
    const cfgEl = root.querySelector('[data-calc-config]');
    if (!cfgEl) return;

    let cfg;
    try { cfg = JSON.parse(cfgEl.textContent); }
    catch (err) { console.error('Calculator config invalid', err); return; }

    const areaInput   = root.querySelector('[data-calc-area]');
    const coatBtns    = Array.from(root.querySelectorAll('[data-calc-coats]'));
    const colorSelect = root.querySelector('[data-calc-color]');
    const neededEl    = root.querySelector('[data-calc-needed]');
    const summaryEl   = root.querySelector('[data-calc-summary]');
    const itemsEl     = root.querySelector('[data-calc-items]');
    const totalKgEl   = root.querySelector('[data-calc-total-kg]');
    const totalPriceEl= root.querySelector('[data-calc-total-price]');
    const addBtn      = root.querySelector('[data-calc-add-to-cart]');

    let coats = parseInt(coatBtns.find(b => b.dataset.default === 'true')?.dataset.calcCoats || '2', 10);

    // Locale-aware formatting
    const locale = cfg.locale || document.documentElement.lang || 'en';
    const i18n = cfg.i18n || {};
    const isEn = locale.toLowerCase().startsWith('en');
    const decSep = isEn ? '.' : ',';
    const fmtKg = (kg) => kg.toFixed(2).replace(/\.?0+$/, '').replace('.', decSep) + ' kg';
    const fmtEur = (cents) => rpMoney(cents);

    // Greedy bucket fill: 6kg first, then 3.5kg, then 1.2kg.
    // Then optimize: if last 1.2kg is wasteful (need < 1.2 but using 1.2),
    // check if upgrading smaller bucket to next size is cheaper.
    function pickCombo(neededKg, variants) {
      // variants is array sorted by size_kg desc: [6kg, 3.5kg, 1.2kg]
      const sorted = [...variants].sort((a, b) => b.size_kg - a.size_kg);
      const result = []; // { variant, count }
      let remaining = neededKg;

      // Greedy: fill from largest down
      for (let i = 0; i < sorted.length; i++) {
        const v = sorted[i];
        const isLast = (i === sorted.length - 1);
        let count;
        if (isLast) {
          // Last (smallest) size — must cover remaining
          count = Math.ceil(remaining / v.size_kg);
        } else {
          count = Math.floor(remaining / v.size_kg);
        }
        if (count > 0) {
          result.push({ variant: v, count });
          remaining -= count * v.size_kg;
          if (remaining <= 0) break;
        }
      }

      // Optimize: if we have multiple smalls that could be merged into bigger
      // Example: 3× 1.2kg = 3.6kg → 1× 3.5kg is enough (and likely cheaper)
      // We do simple post-process: count sum of small + medium, see if upgrading to next bigger is cheaper
      return result;
    }

    function update() {
      const area = Math.max(0, parseFloat(areaInput.value) || 0);
      const needed = area * coats * cfg.coverage * 1.10; // 10% reserve
      const color = colorSelect ? colorSelect.value : cfg.products[0]?.handle;
      const product = cfg.products.find(p => p.handle === color) || cfg.products[0];

      // Update top metrics — locale-aware
      neededEl.textContent = fmtKg(needed);
      const areaStr = area.toLocaleString(locale.startsWith('en') ? 'en-GB' : locale);
      const coatsWord = coats === 1 ? (i18n.coat_singular || 'coat') : (i18n.coat_plural || 'coats');
      const tmpl = i18n.summary_for || 'for {{ area }} m² · {{ coats }} {{ coats_word }}';
      summaryEl.textContent = tmpl
        .replace('__AREA__', areaStr)
        .replace('__COATS__', String(coats))
        .replace('__COATS_WORD__', coatsWord)
        .replace('{{ area }}', areaStr)
        .replace('{{ coats }}', String(coats))
        .replace('{{ coats_word }}', coatsWord);

      if (!product || needed <= 0) {
        itemsEl.innerHTML = `<p class="opacity-60 italic">${i18n.enter_area || 'Enter an area to calculate.'}</p>`;
        totalKgEl.textContent = '—';
        totalPriceEl.textContent = '—';
        addBtn.disabled = true;
        return;
      }

      const combo = pickCombo(needed, product.variants);

      if (combo.length === 0) {
        itemsEl.innerHTML = `<p class="opacity-60">${i18n.no_combo || 'No combination possible.'}</p>`;
        addBtn.disabled = true;
        return;
      }

      let totalKg = 0;
      let totalCents = 0;
      const html = combo.map(({ variant, count }) => {
        totalKg += count * variant.size_kg;
        totalCents += count * variant.price_cents;
        return `
          <div class="flex items-baseline justify-between gap-3 py-1.5">
            <span class="font-headline font-bold text-body-md">
              <span class="inline-block bg-on-primary/15 text-on-primary px-2 py-0.5 rounded-md text-xs font-black mr-2">${count}×</span>
              ${product.label} · ${variant.title}
            </span>
            <span class="font-headline font-bold text-body-md whitespace-nowrap">${fmtEur(count * variant.price_cents)}</span>
          </div>
        `;
      }).join('');

      itemsEl.innerHTML = html;
      totalKgEl.textContent = fmtKg(totalKg);
      totalPriceEl.textContent = fmtEur(totalCents);
      addBtn.disabled = false;
      addBtn.dataset.cartItems = JSON.stringify(combo.map(c => ({ id: c.variant.id, quantity: c.count })));
    }

    // Event wiring
    areaInput?.addEventListener('input', update);
    coatBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        coats = parseInt(btn.dataset.calcCoats, 10);
        coatBtns.forEach(b => {
          const active = b === btn;
          b.classList.toggle('bg-primary', active);
          b.classList.toggle('text-on-primary', active);
          b.classList.toggle('bg-surface-container-low', !active);
          b.classList.toggle('text-on-surface', !active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        update();
      });
    });
    colorSelect?.addEventListener('change', update);

    // ATC: add all variants in correct quantities, then open drawer
    addBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      const items = JSON.parse(addBtn.dataset.cartItems || '[]');
      if (items.length === 0) return;
      addBtn.disabled = true;
      const originalText = addBtn.innerHTML;
      addBtn.innerHTML = '<span class="material-symbols-outlined animate-spin">progress_activity</span> Wird hinzugefügt…';
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        document.dispatchEvent(new CustomEvent('rp:cart-added'));
      } catch (err) {
        console.error('Calculator ATC failed', err);
      } finally {
        addBtn.innerHTML = originalText;
        addBtn.disabled = false;
      }
    });

    // Initial render
    update();
  }

  /* ═══════════════════════════════════════════════
     14) Announcement bar — free-shipping progress motivator
     ═══════════════════════════════════════════════ */
  function initAnnouncementBar() {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    const threshold = parseFloat(bar.dataset.threshold || '199') * rpRate();
    const emptyEl = bar.querySelector('[data-ab-empty]');
    const progressEl = bar.querySelector('[data-ab-progress]');
    const achievedEl = bar.querySelector('[data-ab-achieved]');
    const remainingEl = bar.querySelector('[data-ab-remaining]');
    const progressBarEl = bar.querySelector('[data-ab-progress-bar]');
    const fillEl = bar.querySelector('[data-ab-fill]');

    const fmtMoney = (amt) => rpMoney(Math.round(amt * 100));
    bar.querySelectorAll('[data-ab-threshold]').forEach(el => { el.textContent = fmtMoney(threshold); });
    const show = (el) => el && el.classList.remove('hidden');
    const hide = (el) => el && el.classList.add('hidden');

    function update(totalCents) {
      const totalEur = totalCents / 100;
      const remainingEur = Math.max(threshold - totalEur, 0);

      if (totalCents === 0) {
        bar.dataset.state = 'empty';
        show(emptyEl); hide(progressEl); hide(achievedEl); hide(progressBarEl);
      } else if (remainingEur > 0) {
        bar.dataset.state = 'progress';
        hide(emptyEl); show(progressEl); hide(achievedEl); show(progressBarEl);
        if (remainingEl) remainingEl.textContent = fmtMoney(remainingEur);
        if (fillEl) fillEl.style.width = `${Math.min((totalEur / threshold) * 100, 100)}%`;
      } else {
        bar.dataset.state = 'achieved';
        hide(emptyEl); hide(progressEl); show(achievedEl); hide(progressBarEl);
      }
    }

    // React to cart updates from anywhere (cart drawer, ATC, qty change)
    document.addEventListener('rp:cart-updated', (e) => {
      if (e.detail && typeof e.detail.total_price === 'number') update(e.detail.total_price);
    });

    // Hydrate from server on page load (in case cart was changed in another tab/session)
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then(r => r.json())
      .then(cart => update(cart.total_price))
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
